import { apiFetcher } from '../api-fetcher';

export type RecommendProductsParams = {
  pid:string;
  cursor?:string;
  context?:{
    [key:string]:string;
  }
}

interface Tracking {
  imp_id: string;
  ref_code: string;
  ref_content: string;
}

export interface RecommendProduct {
  type: string;
  pid: string;
  productName: string;
  status: number;
  price: number;
  ad: boolean;
  buntalkCount: number;
  care: boolean;
  favoriteCount: number;
  appUrl: string;
  uid: string;
  productImage: string;
  isFavorite: boolean;
  location: string;
  video: boolean;
  updatedBefore: string;
  createdBefore: string;
  tracking: Tracking;
  discount? : {
    rate?:number
  }
}

interface RecommendProductsResponse {
  size: number;
  title: string;
  data: RecommendProduct[];
}

export const getRecommendProducts = async (params:RecommendProductsParams) => {
  return apiFetcher.get<RecommendProductsResponse>(`/api/rec/v1/mercari/recommend-products`, params);
};


